import { store } from "../common/store/configureStore";
import { Colors } from "../theme";
import moment from "moment";
import GLOBAL_CONST from "./AppConstants";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { extendWith } from "lodash";
import { Callbacks } from "jquery";
import { Slide, toast } from "react-toastify";

export const isAnnounceTimeStarted = (DismissalTime) => {
  let AnnounceTimeStarted = false;
  const AnnounceStartTime = new Date(`1/1/2015 ${DismissalTime}`);
  const todaysDate = new Date();
  const LocalDateTime = new Date(
    `1/1/2015 ${todaysDate.getHours()}:${todaysDate.getMinutes()}`
  );

  if (AnnounceStartTime <= LocalDateTime) {
    AnnounceTimeStarted = true;
  }
  // // console.log(
  //   '******** AnnounceTimeStarted && canAnnounce ',
  //   AnnounceTimeStarted,
  // );
  return AnnounceTimeStarted;
};
export const isAnnounceAllowed = (
  DismissalTime,
  PickupModeAllowsAnnounce,
  Status,
  isLastDayOfSchoolPast
) => {
  if (isLastDayOfSchoolPast && isLastDayOfSchoolPast === true) return false;
  const AnnounceTimeStarted = isAnnounceTimeStarted(DismissalTime);
  let canAnnounce = false;
  let isNotDismissed = true;
  // const canAnnounce = !((dismissalType === 'Bus') || (dismissalType === 'After School'));
  isNotDismissed = Status == 0 || Status == 5;
  canAnnounce = PickupModeAllowsAnnounce;
  // console.log(
  //   '******** AnnounceTimeStarted && canAnnounce ',
  //   AnnounceTimeStarted,
  //   canAnnounce,
  // );
  return AnnounceTimeStarted && canAnnounce && isNotDismissed;
};
export const isKidAnnounceable = (
  DismissalTime,
  PickupModeAllowsAnnounce,
  isLastDayOfSchoolPast
) => {
  if (isLastDayOfSchoolPast && isLastDayOfSchoolPast === true) return false;
  const AnnounceTimeStarted = isAnnounceTimeStarted(DismissalTime);
  let canAnnounce = false;
  canAnnounce = PickupModeAllowsAnnounce;
  // console.log(
  //   '******** AnnounceTimeStarted && canAnnounce ',
  //   AnnounceTimeStarted,
  //   canAnnounce,
  // );
  return AnnounceTimeStarted && canAnnounce;
};

export const getRegistrationToken = () => {
  const state = store.getState();
  let RegistrationTokenID = "";

  const { userAccount } = state;
  if (userAccount) {
    const { registeredResultCache } = userAccount;
    RegistrationTokenID = registeredResultCache.RegistrationTokenID;
  }
  // console.log(` getRegistrationToken ${RegistrationTokenID}`);
  return RegistrationTokenID;
};
export const validateResponse = async (response) => {
  if (response.status === 200) {
    return response.data;
  }
  // console.log(`validateResponse ${JSON.stringify(response)}`);
  let msg = "Unable to process request";
  if (typeof response.data === "string") {
    msg = response.data.toString();
  } else if (response.Message) {
    msg = response.Message.toString();
  } else if (response.message) {
    msg = response.message.toString();
  } else if (response.error) {
    msg = response.error.toString();
  } else if (response.data && response.data.error) {
    msg = response.data.error.toString();
  }
  return {
    status: response.status,
    message: msg,
    error: msg,
  };
};

export const isLoggedIn = () => {
  const state = store.getState();
  let AuthTokenID;

  const { userAccount } = state;
  if (userAccount) {
    const { registeredResultCache, userLoginInfo } = userAccount;
    if (userLoginInfo) {
      AuthTokenID = userLoginInfo.AuthTokenID;
    }
  }
  return AuthTokenID !== null && AuthTokenID !== undefined && AuthTokenID != "";
};

export const getAuthToken = () => {
  const state = store.getState();
  let AuthTokenID = "";

  const { userAccount } = state;
  if (userAccount) {
    const { userLoginInfo } = userAccount;
    if (userLoginInfo) {
      AuthTokenID = userLoginInfo.AuthTokenID;
    }
  }
  return AuthTokenID;
};

// export const getMarkStyle = (record) => {
//   if (record.MiscellaneousID !== null) {
//     return {
//       selected: true,
//       selectedColor:
//         record.IsApproved === true ? Colors.red : Colors.lightOrange,
//       className: record.IsApproved === true ? "pickupRed" : "pickupLightOrange",
//       record,
//     };
//   }
//   if (record.Guardian_First !== "" && record.Guardian_First !== null) {
//     return {
//       selected: true,
//       selectedColor:
//         record.IsApproved === true ? Colors.green : Colors.lightOrange,
//       className:
//         record.IsApproved === true ? "pickupGreen" : "pickupLightOrange",
//       record,
//     };
//   }
//   if (record.RecordSource !== "DefaultPickupEntry") {
//     return {
//       selected: true,
//       selectedColor:
//         record.IsApproved === true ? Colors.green : Colors.lightOrange, // "#7AC943"
//       className:
//         record.IsApproved === true ? "pickupGreen" : "pickupLightOrange", // "#7AC943"
//       record,
//     };
//   }
//   return {
//     record,
//     selectedColor: "rgba(255, 255, 255, 0)",
//     className: "pickupPlain",
//   };
// };

export const getMarkStyle = (record, needColor) => {
  if (record.isEarlyDismissal) {
    return {
      selected: true,
      selectedColor: record.IsApproved === true ? Colors.black : Colors.gray,
      foreGroundColor: record.IsApproved === true ? Colors.white : Colors.black,
      className: record.IsApproved === true ? "pickupBlack" : "pickupGray",
      record,
    };
  }
  if (record.MiscellaneousID !== null) {
    return {
      selected: true,
      selectedColor:
        record.IsApproved === true ? Colors.red : Colors.lightOrange,
      foreGroundColor: record.IsApproved === true ? Colors.white : Colors.black,
      className: record.IsApproved === true ? "pickupRed" : "pickupLightOrange",
      record,
    };
  }
  if (record.Guardian_First !== "" && record.Guardian_First !== null) {
    return {
      selected: true,
      selectedColor:
        record.IsApproved === true ? Colors.green : Colors.lightOrange,
      foreGroundColor: record.IsApproved === true ? Colors.white : Colors.black,
      className:
        record.IsApproved === true ? "pickupGreen" : "pickupLightOrange",
      record,
    };
  }
  if (record.RecordSource !== "DefaultPickupEntry") {
    return {
      selected: true,
      selectedColor:
        record.IsApproved === true ? Colors.green : Colors.lightOrange, // "#7AC943"
      foreGroundColor: record.IsApproved === true ? Colors.white : Colors.black,
      className:
        record.IsApproved === true ? "pickupGreen" : "pickupLightOrange", // "#7AC943"
      record,
    };
  }
  // d44a4a -- absent
  // console.log("record ", record);
  // markedDates[day] = {selected: true, marked: true, selectedColor: '#d44a4a'};
  return {
    record,
    selectedColor: needColor ? Colors.graySubtle : Colors.white,
    foreGroundColor: Colors.grayLabel,
    className: "pickupPlain",
  };
};

export const isTodayAndAnnounced = (selectedDate, ChildInfo) => {
  return (
    moment(selectedDate).isSame(moment(), "day") &&
    (ChildInfo.StatusID === GLOBAL_CONST.PICKUP_STATUS.ANNOUNCED ||
      ChildInfo.StatusID === GLOBAL_CONST.PICKUP_STATUS.DISMISSED)
  );
};

export const isActionAllowed = (DismissalTime, calendarDate) => {
  let isFuture = moment(calendarDate).isAfter(moment());
  if (isFuture === true) return true;

  let caldt = new Date(calendarDate);
  caldt = moment(caldt).format("MM/DD/YYYY");
  caldt = new Date(`${caldt} ${DismissalTime}`);
  isFuture = moment(caldt).isAfter(moment());
  // console.log(`isActionAllowed calendarDate ${calendarDate} caldt ${caldt} isFuture ${isFuture} `);
  return isFuture;
};

export const getDismissalInfo = (item) => {
  const currentDate = new Date();

  let dismissalText = "";
  let dismissalTextSubText = "";

  const isFuture = moment(item.CalendarDate).isAfter(moment(currentDate));

  if (item.MiscellaneousID !== null) {
    dismissalText = item.PM_Name;
    dismissalTextSubText = item.PM_SubName;
    // dismissalTextSubText = item.PM_IconID;
  } else if (item.PM_Name === "After School") {
    dismissalText = item.PM_Name;
    dismissalTextSubText = item.PM_SubName;
    if (item.Guardian_First || item.Guardian_Last) {
      dismissalTextSubText += ` ${item.Guardian_First} ${item.Guardian_Last} (${
        item.Guardian_Phone
      }) ${"will be picking up"}`;
    }
  } else if (item.Guardian_First !== "" && item.Guardian_First !== null) {
    if (isFuture) {
      dismissalText = `${item.Guardian_First} ${item.Guardian_Last} (${
        item.Guardian_Phone
      }) ${"will be picking up"} - ${item.PM_Name}`;
    } else {
      dismissalText = `${item.Guardian_First} ${item.Guardian_Last} (${
        item.Guardian_Phone
      })  ${"Picked up"} - ${item.PM_Name}`;
    }

    dismissalTextSubText = item.PM_SubName;
  } else {
    if (isFuture) {
      if (item.PM_Name === "Bus") {
        dismissalText = `${"Pickup is by"} - ${item.PM_Name}`;
      } else if (item.StatusID > 0) {
        dismissalText = `${"Picked up"} - ${item.PM_Name}`;
      } else {
        dismissalText = `${"Pickup is by"} - ${item.PM_Name}`;
      }
    } else if (item.PM_Name === "Bus") {
      dismissalText = `${"Pickup is by"} - ${item.PM_Name}`;
    } else if (item.StatusID > 0) {
      dismissalText = `${"Picked up"} - ${item.PM_Name}`;
    } else {
      dismissalText = `${"Pickup was by"} - ${item.PM_Name}`;
    }
    dismissalTextSubText = item.PM_SubName;
  }

  // else {
  //   if (isFuture) dismissalText = `You are picking up - ${item.PM_Name}`;
  //   else dismissalText = `${'Pickup was by'} - ${item.PM_Name}`;

  //   dismissalTextSubText = item.PM_SubName;
  // }

  return {
    dismissalText,
    dismissalTextSubText:
      dismissalTextSubText === null ? "" : `-${dismissalTextSubText}`,
  };
};

export const getEarlyDismissalInfo = (item) => {
  const currentDate = new Date();

  let dismissalText = "";
  const dismissalTextSubText = "";

  const isFuture = moment(item.Date).isAfter(moment(currentDate));

  if (item.DelegateName) {
    if (isFuture) {
      dismissalText = `${item.DelegateName}`;
    } else {
      dismissalText = `${item.DelegateName}`;
    }
  } else if (isFuture) {
    dismissalText = `${this.props.t("Pickup_Early_By_Text")}`;
  } else {
    dismissalText = `${this.props.t("Pickup_Early_Was_By_Text")}`;
  }

  return {
    dismissalText,
    dismissalTextSubText:
      dismissalTextSubText === null ? "" : `-${dismissalTextSubText}`,
  };
};

export const filterByTypes = (markedDates) => {
  const pickupRed = [];
  const pickupLightOrange = [];
  const pickupGreen = [];

  for (var key in markedDates) {
    if (markedDates[key].className == "pickupRed") {
      pickupRed.push(new Date(key));
    } else if (markedDates[key].className == "pickupLightOrange") {
      pickupLightOrange.push(new Date(key));
    } else if (markedDates[key].className == "pickupGreen") {
      pickupGreen.push(new Date(key));
    }
  }
  return {
    pickupRed,
    pickupLightOrange,
    pickupGreen,
  };
};

export const getChildStatus = (childInfo) => {
  //console.log(` ${childInfo.Firstname} getChildStatus ${childInfo.Status_EN} + childInfo.Status_ES ${+childInfo.Status_ES}`);
  const lang = getLanguageCode().toUpperCase();
  let status = childInfo[`Status_${lang}`];
  if (!status) status = childInfo.Status_EN;
  return status;
};

export const getLanguageCode = () => {
  let locale = i18next.use(LanguageDetector).language;
  // console.log("locale ", i18next.use(LanguageDetector))
  // console.log("locale ", locale)
  if (locale.indexOf("-") >= 0) {
    locale = locale.split("-");
    if (locale.length > 0) return locale[0];
  }
  return locale;
};

export const validateError = (response) => {
  let msg = "Unable to process request";
  if (response.Message) {
    msg = response.Message.toString();
  } else if (response.message) {
    msg = response.message.toString();
  } else if (response.error) {
    msg = response.error.toString();
  } else if (response.data && response.data.error) {
    msg = response.data.error.toString();
  }

  if (msg === "Network Error") {
    msg = "Please check your network connection.";
  }
  const retRes = {
    message: msg,
    error: msg,
  };

  return retRes;
};

export const getPickupMode = (availableDispatch, selectedItem) => {
  let pickupString = "";
  let pickupMode = [];
  let selectedId = 0;

  if (availableDispatch.StudentDismissalMethod) {
    const student = availableDispatch.StudentDismissalMethod.filter(
      (item) => item.StudentID === selectedItem.StudentID
    );
    if (student && student.length > 0)
      pickupMode = student[0].Modes.filter(
        (item) => item.PickupModeID === selectedItem.DefaultPickupModeID
      );
  }
  if (availableDispatch.MethodsAvailableToEveryone) {
    if (pickupMode.length === 0)
      pickupMode = availableDispatch.MethodsAvailableToEveryone.filter(
        (item) => item.PickupModeID === selectedItem.DefaultPickupModeID
      );
  }
  // if(selectedItem.StudentID == 11232){
  // console.log("getPickupMode student ", availableDispatch.StudentDismissalMethod)
  // console.log("getPickupMode selectedItem ", selectedItem)
  // console.log("getPickupMode ", pickupMode)
  // }

  if (pickupMode.length > 0) {
    const mode = pickupMode[0];
    if (mode.PickupModeID == 4) {
      pickupString = mode.Name + " " + selectedItem.DefaultInstituteName;
    } else if (mode.PickupModeID == 1) {
      pickupString = mode.Name + " " + selectedItem.DefaultBusRoute;
    } else {
      pickupString = mode.Name;
    }
  }
  return pickupString;
};

export const getModifiedPickupMode = (availableDispatch, selectedItem) => {
  let pickupString = "";
  let pickupMode = [];
  let selectedId = 0;

  if (availableDispatch.StudentDismissalMethod) {
    const student = availableDispatch.StudentDismissalMethod.filter(
      (item) => item.StudentID === selectedItem.StudentID
    );
    if (student && student.length > 0)
      pickupMode = student[0].Modes.filter(
        (item) => item.PickupModeID === selectedItem.fk_pickmodeid
      );
  }
  if (availableDispatch.MethodsAvailableToEveryone) {
    if (pickupMode.length === 0)
      pickupMode = availableDispatch.MethodsAvailableToEveryone.filter(
        (item) => item.PickupModeID === selectedItem.fk_pickmodeid
      );
  }
  // console.log("getModifiedPickupMode student ", student)
  // console.log("getModifiedPickupMode selectedItem ", selectedItem)
  // console.log("getModifiedPickupMode ", pickupMode)

  if (pickupMode.length > 0) {
    const mode = pickupMode[0];
    let subPickupMode;
    if (mode.SubOptions)
      subPickupMode = mode.SubOptions.filter(
        (item) => item.ID === selectedItem.fk_institutionid
      );
    // console.log("getModifiedPickupMode ", mode)
    let subString = "";
    if (subPickupMode && subPickupMode.length > 0)
      subString = subPickupMode[0].Name;
    else if (selectedItem.ChangedToInstitutionName)
      subString = selectedItem.ChangedToInstitutionName;
    if (mode.PickupModeID == 4) {
      pickupString = mode.Name + " " + subString;
    } else if (mode.PickupModeID == 1) {
      pickupString = mode.Name + " " + subString;
    } else {
      if (selectedItem.guardianfirstname) {
        pickupString = `${selectedItem.guardianfirstname} ${
          selectedItem.guardianlastname
        } (${selectedItem.guardianphonenumber}) ${"will be picking up"} - ${
          mode.Name
        }`;
        // pickupString = mode.Name
      } else {
        pickupString = mode.Name;
      }
    }
  }
  return pickupString;
};

export const getSiteAccessPermission = async () => {
  try {
    const result = await navigator.permissions.query({ name: "geolocation" });
    // console.log("result getSiteAccessPermission ", result)
    if (result && result.state) return result.state;
    else return "prompt";
  } catch (ex) {
    console.error(ex);
  }
  return "prompt";
};

export const showLocationError = (msg) => {
  toast.error(msg, {
    autoClose: 2000,
    transition: Slide,
    hideProgressBar: true,
  });
};

export const deg2rad = (deg) => deg * (Math.PI / 180);

export const distance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  const df = parseFloat(d) * 1093.61;
  return df;
};

export const nextField = (event) => {
  const form = event.target.form;
  const index = Array.prototype.indexOf.call(form, event.target);
  if (event.key === "Enter") {
    form.elements[index + 1].focus();
  }
};

export const formatPhone = function (phone) {
  const AllowedCharacters = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "(",
    ")",
    "-",
    "+",
  ];
  const tempStr = phone.trim().split(""); // Creates array
  for (let i = phone.length; i >= 0; i--) {
    if (AllowedCharacters.indexOf(tempStr[i]) < 0) {
      // Plus Symbol not included in allowed characters,  but it is allowed in position 0
      if (i > 0 || (i == 0 && tempStr[i] != "+")) {
        tempStr.splice(i, 1);
      }
    }
  }
  return tempStr.join("");
};

export const parseDaytime = (time) => {
  let [hours, minutes] = time
    .substr(0, time.length - 2)
    .split(":")
    .map(Number);
  if (time.toLowerCase().includes("pm") && hours !== 12) hours += 12;
  return [hours, minutes];
};

export const isEarlyDismissalAvailable = (school, selectedDate, pickedTime,props) => {
  const response = {
    success: false,
    message: '',
  };
  const dayNo = new Date(selectedDate).getDay();
  

  const { EarlyDismissalSettings } = school;
  if (EarlyDismissalSettings && EarlyDismissalSettings.AllowParentSameDayScheduling === false && moment(selectedDate).isSame(moment(), 'date')) {
    response.message = `${props.t("early_dismissal_allow_today_message")}`;
    return response;
  }
  const records = EarlyDismissalSettings && EarlyDismissalSettings.EarlyDismissalTimeTable.filter(
    (item) => item.Day.toLowerCase() === moment(selectedDate).format('dddd').toLowerCase(),
  );

  if (records && records.length === 0) {
    response.success = true;
    return response;
  }
  const scheduleRecord = records && records[0];

  if (scheduleRecord && scheduleRecord.Active === false && moment(selectedDate).isSame(moment(), 'date')) {
    response.message = `${props.t("early_dismissal_allow_today_message")}`
    return response;
  }
  const dayText = getLanguageCode() === 'es' ? GLOBAL_CONST.DAYS_FULL_ES[dayNo] : GLOBAL_CONST.DAYS_FULL_EN[dayNo];
  if (scheduleRecord && scheduleRecord.Active === false) {
    let msg = `${props.t("early_dismissal_allow_inActive_message")}`
    msg = msg.replace('#Day#', dayText);
    response.message = msg;
    return response;
  }
  let StartTime = new Date(`1/1/2015 ${scheduleRecord.StartTime}`);
  let EndTime = new Date(`1/1/2015 ${scheduleRecord.EndTime}`);
  StartTime = moment(StartTime).format('hh:mm A');
  EndTime = moment(EndTime).format('hh:mm A');
  let pickTime = moment(pickedTime).format('hh:mm A');
  const compareDate = moment(pickTime, 'hh:mm A');
  const startDate = moment(StartTime, 'hh:mm A');
  const endDate = moment(EndTime, 'hh:mm A');

  if (compareDate.isBetween(startDate, endDate)
  || compareDate.isSame(startDate) || compareDate.isSame(endDate)) {
    response.success = true;
    return response;
  }

  let msg = `${props.t("early_dismissal_schedule_warning")}`
  msg = msg.replace('#Day#', dayText);
  msg = msg.replace('#starttime#', moment(startDate).format('hh:mm A'));
  msg = msg.replace('#endtime#', moment(endDate).format('hh:mm A'));
  response.message = msg;
  return response;
};
 
export const canEarlyDismissToday = (school) => {
  const { EarlyDismissalSettings } = school;
  if (school.ReunificationEnabled) return false;
  
  if (!EarlyDismissalSettings) return false;
  if (EarlyDismissalSettings.AllowParentEarlyDismissals === false) return false;
  const timeTable = school.EarlyDismissalSettings.EarlyDismissalTimeTable;
  const daySelectedIndex = moment(new Date()).format('d');
  const todayRecord = timeTable[daySelectedIndex];
  if (!todayRecord || !todayRecord.Active) return false;
  return EarlyDismissalSettings.AllowParentSameDayScheduling;
};

export const earlyDismissNeedPassword = (school) => {
  const { EarlyDismissalSettings } = school;
  if (!EarlyDismissalSettings) return false;
  if (EarlyDismissalSettings.RequireParentPasswordForEarlyDismissal === false)
    return false;
  return EarlyDismissalSettings.RequireParentPasswordForEarlyDismissal;
};

export const getEarlyDismissalTime = (item) => {
  let caldt = new Date(item.Date);
  caldt = moment(caldt).format("MM/DD/YYYY");
  caldt = new Date(`${caldt} ${item.Time}`);
  return moment(caldt).format("hh:mm A");
};
export const toTitleCase = (value) => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
};
export const createImageFileURL = (imageFile) => {
  return URL.createObjectURL(imageFile);
};

export const checkIsEmergency = (delegate) => {
  if (
    delegate !== null &&
    delegate !== undefined &&
    delegate.Students !== null &&
    delegate.Students !== undefined &&
    delegate.Students.length > 0
  ) {
    return delegate.Students.find((item) => item.IsEmergency);
  }

  return false;
};
